"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Category;
(function (Category) {
    Category["All"] = "All";
    Category["Alpha"] = "Alpha";
    Category["Beta"] = "Beta";
    Category["JensenAlpha"] = "JensenAlpha";
    Category["BattingAverage"] = "BattingAverage";
    Category["BestPeriod"] = "BestPeriod";
    Category["WorstPeriod"] = "WorstPeriod";
    Category["Kurtosis"] = "Kurtosis";
    Category["NumOfPositivePeriods"] = "NumOfPositivePeriods";
    Category["NumOfNegativePeriods"] = "NumOfNegativePeriods";
    Category["TotalNumOfPeriods"] = "TotalNumOfPeriods";
    Category["LongestPositivePeriod"] = "LongestPositivePeriod";
    Category["LongestNegativePeriod"] = "LongestNegativePeriod";
    Category["Skewness"] = "Skewness";
    Category["DownsideMarketCaptureRatio"] = "DownsideMarketCaptureRatio";
    Category["UpsideMarketCaptureRatio"] = "UpsideMarketCaptureRatio";
    Category["DownMarketReturn"] = "DownMarketReturn";
    Category["UpMarketReturn"] = "UpMarketReturn";
    Category["Bias"] = "Bias";
    Category["CalendarYearReturns"] = "CalendarYearReturns";
    Category["ExcessReturns"] = "ExcessReturns";
    Category["ExcessReturnsAnnualised"] = "ExcessReturnsAnnualised";
    Category["ExcessReturnsOverRF"] = "ExcessReturnsOverRF";
    Category["ExcessReturnsOverRFAnnualised"] = "ExcessReturnsOverRFAnnualised";
    Category["InformationRatio"] = "InformationRatio";
    Category["OmegaRatio"] = "OmegaRatio";
    Category["TrailingYearReturns"] = "TrailingYearReturns";
    Category["TrailingQuarterReturns"] = "TrailingQuarterReturns";
    Category["TrailingVolatility"] = "TrailingVolatility";
    Category["CumulativeReturn"] = "CumulativeReturn";
    Category["AnnualisedReturn"] = "AnnualisedReturn";
    Category["RiskFreeReturns"] = "RiskFreeReturns";
    Category["RollingAverage"] = "RollingAverage";
    Category["SharpeRatio"] = "SharpeRatio";
    Category["SortinoRatio"] = "SortinoRatio";
    Category["TrackingError"] = "TrackingError";
    Category["StandardDeviation"] = "StandardDeviation";
    Category["GainDeviation"] = "GainDeviation";
    Category["LossDeviation"] = "LossDeviation";
    Category["Drawdown"] = "Drawdown";
    Category["CalmarRatio"] = "CalmarRatio";
    Category["SterlingRatio"] = "SterlingRatio";
    Category["TreynorRatio"] = "TreynorRatio";
    Category["PortfolioCorrelationCovariance"] = "PortfolioCorrelationCovariance";
    Category["PortfolioReturns"] = "PortfolioReturns";
    Category["PortfolioExcessReturnsCorrelation"] = "PortfolioExcessReturnsCorrelation";
    Category["Forecast"] = "Forecast";
    Category["RSquared"] = "RSquared";
    Category["SeriesSplice"] = "SeriesSplice";
})(Category = exports.Category || (exports.Category = {}));
//# sourceMappingURL=Category.js.map